import src from "IMAGE";
export default { src, width: 442, height: 575, blurWidth: 0, blurHeight: 0};
